import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../../i18n';
import MarketingHeader from '../common/MarketingHeader';
import MarketingFooter from '../common/MarketingFooter';
import HomeHero from './HomeHero';
import HowItWorks from './HowItWorks';
import FeatureCards from './FeatureCards';
import CtaBand from './CtaBand';
import FixedCta from './FixedCta';
import '../../../styles/marketing.css';

const Home: React.FC = () => {
  const t = useT();
  return (
    <div className="mk-page has-fixed-cta">
      <MarketingHeader>
        <Link to="/login" className="mkt-btn ghost">
          {t('Se connecter')}
        </Link>
        <Link to="/signup" className="mkt-btn primary mk-header-signup">
          {t('Créer mon espace')}
        </Link>
      </MarketingHeader>

      <main className="mk-main">
        <HomeHero />
        <HowItWorks />
        <FeatureCards />
        <CtaBand />
      </main>

      <MarketingFooter />
      <FixedCta />
    </div>
  );
};

export default Home;
